module.exports = __webpack_public_path__ + "img/object-mark9.826bd746.png";